export const areEnvelopesLoaded: producer = ({
  envelopes = observe.envelopes,
  areEnvelopesLoaded = update.views[prop._viewId].data.areEnvelopesLoaded,
}) => {
  if (!envelopes) {
    areEnvelopesLoaded.set(false);
  } else {
    areEnvelopesLoaded.set(true);
  }
};
